import { PORNDOE_BRAND_TYPE } from '../helpers';

import amateureuroMobileDE from './amateureuro/Mobile/bannerDE.png';
import amateureuroMobileEN from './amateureuro/Mobile/bannerEN.png';
import amateureuroMobileES from './amateureuro/Mobile/bannerES.png';
import amateureuroMobileFR from './amateureuro/Mobile/bannerFR.png';
import amateureuroMobileIT from './amateureuro/Mobile/bannerIT.png';
import amateureuroMobilePT from './amateureuro/Mobile/bannerPT.png';
import amateureuroDesktopDE from './amateureuro/Desktop/bannerDE.png';
import amateureuroDesktopEN from './amateureuro/Desktop/bannerEN.png';
import amateureuroDesktopES from './amateureuro/Desktop/bannerES.png';
import amateureuroDesktopFR from './amateureuro/Desktop/bannerFR.png';
import amateureuroDesktopIT from './amateureuro/Desktop/bannerIT.png';
import amateureuroDesktopPT from './amateureuro/Desktop/bannerPT.png';
import doegirlsMobileDE from './doegirls/Mobile/bannerDE.png';
import doegirlsMobileEN from './doegirls/Mobile/bannerEN.png';
import doegirlsMobileES from './doegirls/Mobile/bannerES.png';
import doegirlsMobileFR from './doegirls/Mobile/bannerFR.png';
import doegirlsMobileIT from './doegirls/Mobile/bannerIT.png';
import doegirlsMobilePT from './doegirls/Mobile/bannerPT.png';
import doegirlsDesktopDE from './doegirls/Desktop/bannerDE.jpg';
import doegirlsDesktopEN from './doegirls/Desktop/bannerEN.jpg';
import doegirlsDesktopES from './doegirls/Desktop/bannerES.jpg';
import doegirlsDesktopFR from './doegirls/Desktop/bannerFR.jpg';
import doegirlsDesktopIT from './doegirls/Desktop/bannerIT.jpg';
import doegirlsDesktopPT from './doegirls/Desktop/bannerPT.jpg';
import letsdoeitMobileDE from './letsdoeit/Mobile/bannerDE.png';
import letsdoeitMobileEN from './letsdoeit/Mobile/bannerEN.png';
import letsdoeitMobileES from './letsdoeit/Mobile/bannerES.png';
import letsdoeitMobileFR from './letsdoeit/Mobile/bannerFR.png';
import letsdoeitMobileIT from './letsdoeit/Mobile/bannerIT.png';
import letsdoeitMobilePT from './letsdoeit/Mobile/bannerPT.png';
import letsdoeitDesktopDE from './letsdoeit/Desktop/bannerDE.jpg';
import letsdoeitDesktopEN from './letsdoeit/Desktop/bannerEN.jpg';
import letsdoeitDesktopES from './letsdoeit/Desktop/bannerES.jpg';
import letsdoeitDesktopFR from './letsdoeit/Desktop/bannerFR.jpg';
import letsdoeitDesktopIT from './letsdoeit/Desktop/bannerIT.jpg';
import letsdoeitDesktopPT from './letsdoeit/Desktop/bannerPT.jpg';
import mamacitazMobileDE from './mamacitaz/Mobile/bannerDE.png';
import mamacitazMobileEN from './mamacitaz/Mobile/bannerEN.png';
import mamacitazMobileES from './mamacitaz/Mobile/bannerES.png';
import mamacitazMobileFR from './mamacitaz/Mobile/bannerFR.png';
import mamacitazMobileIT from './mamacitaz/Mobile/bannerIT.png';
import mamacitazMobilePT from './mamacitaz/Mobile/bannerPT.png';
import mamacitazDesktopDE from './mamacitaz/Desktop/bannerDE.jpg';
import mamacitazDesktopEN from './mamacitaz/Desktop/bannerEN.jpg';
import mamacitazDesktopES from './mamacitaz/Desktop/bannerES.jpg';
import mamacitazDesktopFR from './mamacitaz/Desktop/bannerFR.jpg';
import mamacitazDesktopIT from './mamacitaz/Desktop/bannerIT.jpg';
import mamacitazDesktopPT from './mamacitaz/Desktop/bannerPT.jpg';
import superbeMobileDE from './superbe/Mobile/bannerDE.png';
import superbeMobileEN from './superbe/Mobile/bannerEN.png';
import superbeMobileES from './superbe/Mobile/bannerES.png';
import superbeMobileFR from './superbe/Mobile/bannerFR.png';
import superbeMobileIT from './superbe/Mobile/bannerIT.png';
import superbeMobilePT from './superbe/Mobile/bannerPT.png';
import superbeDesktopDE from './superbe/Desktop/bannerDE.jpg';
import superbeDesktopEN from './superbe/Desktop/bannerEN.jpg';
import superbeDesktopES from './superbe/Desktop/bannerES.jpg';
import superbeDesktopFR from './superbe/Desktop/bannerFR.jpg';
import superbeDesktopIT from './superbe/Desktop/bannerIT.jpg';
import superbeDesktopPT from './superbe/Desktop/bannerPT.jpg';
import transbellaMobileDE from './transbella/Mobile/bannerDE.png';
import transbellaMobileEN from './transbella/Mobile/bannerEN.png';
import transbellaMobileES from './transbella/Mobile/bannerES.png';
import transbellaMobileFR from './transbella/Mobile/bannerFR.png';
import transbellaMobileIT from './transbella/Mobile/bannerIT.png';
import transbellaMobilePT from './transbella/Mobile/bannerPT.png';
import transbellaDesktopDE from './transbella/Desktop/bannerDE.jpg';
import transbellaDesktopEN from './transbella/Desktop/bannerEN.jpg';
import transbellaDesktopES from './transbella/Desktop/bannerES.jpg';
import transbellaDesktopFR from './transbella/Desktop/bannerFR.jpg';
import transbellaDesktopIT from './transbella/Desktop/bannerIT.jpg';
import transbellaDesktopPT from './transbella/Desktop/bannerPT.jpg';
import vipsexvaultMobileDE from './vipsexvault/Mobile/bannerDE.png';
import vipsexvaultMobileEN from './vipsexvault/Mobile/bannerEN.png';
import vipsexvaultMobileES from './vipsexvault/Mobile/bannerES.png';
import vipsexvaultMobileFR from './vipsexvault/Mobile/bannerFR.png';
import vipsexvaultMobileIT from './vipsexvault/Mobile/bannerIT.png';
import vipsexvaultMobilePT from './vipsexvault/Mobile/bannerPT.png';
import vipsexvaultDesktopDE from './vipsexvault/Desktop/bannerDE.jpg';
import vipsexvaultDesktopEN from './vipsexvault/Desktop/bannerEN.jpg';
import vipsexvaultDesktopES from './vipsexvault/Desktop/bannerES.jpg';
import vipsexvaultDesktopFR from './vipsexvault/Desktop/bannerFR.jpg';
import vipsexvaultDesktopIT from './vipsexvault/Desktop/bannerIT.jpg';
import vipsexvaultDesktopPT from './vipsexvault/Desktop/bannerPT.jpg';


export const bannerImagesURLs = {
  mobile: {
    [PORNDOE_BRAND_TYPE.AMATEUREURO]: {
      de: amateureuroMobileDE,
      en: amateureuroMobileEN,
      es: amateureuroMobileES,
      fr: amateureuroMobileFR,
      it: amateureuroMobileIT,
      pt: amateureuroMobilePT,
    },
    [PORNDOE_BRAND_TYPE.DOEGIRLS]: {
      de: doegirlsMobileDE,
      en: doegirlsMobileEN,
      es: doegirlsMobileES,
      fr: doegirlsMobileFR,
      it: doegirlsMobileIT,
      pt: doegirlsMobilePT,
    },
    [PORNDOE_BRAND_TYPE.LETSDOEIT]: {
      de: letsdoeitMobileDE,
      en: letsdoeitMobileEN,
      es: letsdoeitMobileES,
      fr: letsdoeitMobileFR,
      it: letsdoeitMobileIT,
      pt: letsdoeitMobilePT,
    },
    [PORNDOE_BRAND_TYPE.MAMACITAZ]: {
      de: mamacitazMobileDE,
      en: mamacitazMobileEN,
      es: mamacitazMobileES,
      fr: mamacitazMobileFR,
      it: mamacitazMobileIT,
      pt: mamacitazMobilePT,
    },
    [PORNDOE_BRAND_TYPE.SUPERBE]: {
      de: superbeMobileDE,
      en: superbeMobileEN,
      es: superbeMobileES,
      fr: superbeMobileFR,
      it: superbeMobileIT,
      pt: superbeMobilePT,
    },
    [PORNDOE_BRAND_TYPE.TRANSBELLA]: {
      de: transbellaMobileDE,
      en: transbellaMobileEN,
      es: transbellaMobileES,
      fr: transbellaMobileFR,
      it: transbellaMobileIT,
      pt: transbellaMobilePT,
    },
    [PORNDOE_BRAND_TYPE.VIPSEXVAULT]: {
      de: vipsexvaultMobileDE,
      en: vipsexvaultMobileEN,
      es: vipsexvaultMobileES,
      fr: vipsexvaultMobileFR,
      it: vipsexvaultMobileIT,
      pt: vipsexvaultMobilePT,
    },
  },
  desktop: {
    [PORNDOE_BRAND_TYPE.AMATEUREURO]: {
      de: amateureuroDesktopDE,
      en: amateureuroDesktopEN,
      es: amateureuroDesktopES,
      fr: amateureuroDesktopFR,
      it: amateureuroDesktopIT,
      pt: amateureuroDesktopPT,
    },
    [PORNDOE_BRAND_TYPE.DOEGIRLS]: {
      de: doegirlsDesktopDE,
      en: doegirlsDesktopEN,
      es: doegirlsDesktopES,
      fr: doegirlsDesktopFR,
      it: doegirlsDesktopIT,
      pt: doegirlsDesktopPT,
    },
    [PORNDOE_BRAND_TYPE.LETSDOEIT]: {
      de: letsdoeitDesktopDE,
      en: letsdoeitDesktopEN,
      es: letsdoeitDesktopES,
      fr: letsdoeitDesktopFR,
      it: letsdoeitDesktopIT,
      pt: letsdoeitDesktopPT,
    },
    [PORNDOE_BRAND_TYPE.MAMACITAZ]: {
      de: mamacitazDesktopDE,
      en: mamacitazDesktopEN,
      es: mamacitazDesktopES,
      fr: mamacitazDesktopFR,
      it: mamacitazDesktopIT,
      pt: mamacitazDesktopPT,
    },
    [PORNDOE_BRAND_TYPE.SUPERBE]: {
      de: superbeDesktopDE,
      en: superbeDesktopEN,
      es: superbeDesktopES,
      fr: superbeDesktopFR,
      it: superbeDesktopIT,
      pt: superbeDesktopPT,
    },
    [PORNDOE_BRAND_TYPE.TRANSBELLA]: {
      de: transbellaDesktopDE,
      en: transbellaDesktopEN,
      es: transbellaDesktopES,
      fr: transbellaDesktopFR,
      it: transbellaDesktopIT,
      pt: transbellaDesktopPT,
    },
    [PORNDOE_BRAND_TYPE.VIPSEXVAULT]: {
      de: vipsexvaultDesktopDE,
      en: vipsexvaultDesktopEN,
      es: vipsexvaultDesktopES,
      fr: vipsexvaultDesktopFR,
      it: vipsexvaultDesktopIT,
      pt: vipsexvaultDesktopPT,
    },
  },
};
